import React from 'react';

export default ({ height, width }) => {
  return <div style={{ height, width }} />;
};
